import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import EmptyState from '../EmptyState';
import { ListItem } from '../../../shared/components/ListItem';
import { LAYOUT_SOURCES } from '../../../shared/types/layoutSources';
import { selectByShownCount } from './selectors';
import './style.scss';

export function TabContent({ items, drawerType }) {
    if (!items.length) {
        return <EmptyState drawerType={drawerType} />;
    }

    return (
        <ul className="items-list">
            {items.map((item) => (
                <ListItem key={item.id} item={item} layoutSource={LAYOUT_SOURCES.DRAWER} />
            ))}
        </ul>
    );
}

TabContent.propTypes = {
    items: propTypes.array,
    drawerType: propTypes.string,
};

TabContent.defaultProps = {
    items: [],
};

export default connect((state, { name, shownCount, drawerType }) => ({
    items: selectByShownCount(state, name, shownCount),
    drawerType,
}))(TabContent);
